import { getCurrentInstance, onMounted, ref } from 'vue';
import Modal from 'bootstrap/js/src/modal';

export const useBootstrapModal = () => {
    const instance = getCurrentInstance();
    const modal = ref(null);

    onMounted(() => {
        const modal_el = instance.proxy.$refs.modal;
        modal.value = new Modal(modal_el, { focus: true });
        modal_el.addEventListener('hidden.bs.modal', (event) => {
            instance.proxy.$emit('hidden', event);
        });
    });

    const show = () => {
        modal.value.show();
    };

    const hide = () => {
        modal.value.hide();
    };

    return { show, hide };
};

export default useBootstrapModal;
